// extracted by mini-css-extract-plugin
export default {"progressContainer":"CarePlanProgress_progressContainer__I4cp0","hideBorder":"CarePlanProgress_hideBorder__4r+m9"};